$(function () {

  initSliders();
  wroclawTvPlayer();
  newsletter();
  switchButton(); 
  showMoreContent($("[data-more-info]"), 3);
  showMoreContent($("[data-switch-more-info]"), 2);
  bottomStickyBar();
});


/* ---------------- SLIDERS ---------------------------------------------------------------- */

function SlideNumber(Splide, Components) {
  const { track } = Components.Elements;

  let elm;

  function mount() {
    elm = document.createElement("div");
    elm.className = "slideNumber";

    track.parentElement.insertBefore(elm, track.nextSibling);

    update();
    Splide.on("move", update);
  }

  function update() {
    elm.textContent = `${Splide.index + 1} z ${Splide.length}`;
  }

  return {
    mount,
  };
}


// document.addEventListener("DOMContentLoaded", function() {
//   $('[data-slider-loader]').each(function() {
//     $(this).addClass('hidden');
//   });

//   if ($("[data-promo-box-slider]").length > 0) {
//     $("[data-promo-box-slider] .promoSlider").each(function () {
//       var sliderId = $(this).attr("id");
//       new Splide("#" + sliderId, {
//         perPage: 6,
//         perMove: 6,
//         pagination: true,
//         gap: "20px",
//         interval: 3000,
//         breakpoints: {
//           1979: {
//             perPage: 5,
//             perMove: 5,
//           },
//           1279: {
//             perPage: 4,
//             perMove: 4,
//           },
//           991: {
//             perPage: 3,
//             perMove: 3,
//           },
//           767: {
//             pagination: false,
//             perPage: 2,
//             perMove: 2,
//           },
//           575: {
//             pagination: false,
//             perPage: 1,
//             perMove: 1,
//             padding: {
//               right: 80,
//             },
//           },
//         },
//       }).mount({
//         SlideNumber,
//       });
//     });
//   }
// });


function initSliders() {
  Splide.defaults = {
    i18n: {
      prev: "Poprzedni slajd",
      next: "Następny slajd",
      pageX: "Strona %s",
      slideX: "Strona %s",
    },
  };

  /* --------------------------- Icon slider --------------------------- */
  if ($("[data-iconslider] li").length >= 6 && $(window).width() > 768) {
    $("[data-iconslider]").each(function () {
      var sliderId = $(this).attr("id");
      new Splide("#" + sliderId, {
        perPage: 6,
        perMove: 6,
        pagination: true,
        interval: 3000,
        speed: 1500,
        breakpoints: {
          1199: {
            perPage: 4,
            perMove: 4,
          },
          991: {
            perPage: 3,
            perMove: 3,
          },
          767: {
            pagination: false,
            // perPage    : 3,
            // perMove    : 3,
          },
          500: {
            pagination: false,
            perPage: 2,
            perMove: 2,
          },
        },
      }).mount({
        SlideNumber,
      });
    });
  } else if ($("[data-iconslider] li").length > 2 && $(window).width() < 768) {
    $("[data-iconslider]").each(function () {
      var sliderId = $(this).attr("id");
      new Splide("#" + sliderId, {
        perPage: 2,
        perMove: 2,
        pagination: false,
        interval: 3000,
      }).mount({
        SlideNumber,
      });
    });
  }

  /* --------------------------- Wroclaw Tv slider --------------------------- */
  if ($(window).width() < 768 && $("[data-tv-box]").length > 0) {
    new Splide(".tvSlider", {
      perPage: 2,
      pagination: false,
      arrows: false,
      gap: "30px",
      interval: 3000,
      breakpoints: {
        767: {
          perPage: 1,
          perMove: 1,
          padding: {
            right: 200,
          },
        },
        575: {
          perPage: 1,
          perMove: 1,
          padding: {
            right: 120,
          },
        },
      },
    }).mount();
  }

  /* --------------------------- President section - projects slider --------------------------- */
  if ($("[data-projects]").length > 0) {
    $("[data-projects] [data-projects-slider]").each(function () {
      var sliderId = $(this).attr("id");
      new Splide("#" + sliderId, {
        perPage: 5,
        perMove: 5,
        pagination: true,
        gap: "20px",
        interval: 3000,
        breakpoints: {
          4000: {
            perPage: 4,
            perMove: 4,
          },
          2000: {
            perPage: 3,
            perMove: 3,
          },
          1279: {
            perPage: 2,
            perMove: 2,
          },
          767: {
            pagination: false,
            perPage: 2,
            perMove: 2,
          },
          575: {
            pagination: false,
            perPage: 1,
            perMove: 1,
            padding: {
              right: 80,
            },
          },
        },
      }).mount({
        SlideNumber,
      });
    });

    $("[data-projects-slider-alone]").each(function () {
      var sliderId = $(this).attr("id");
      new Splide("#" + sliderId, {
        perPage: 4,
        perMove: 4,
        pagination: true,
        gap: "20px",
        interval: 3000,
        breakpoints: {
          1279: {
            perPage: 3,
            perMove: 3,
          },
          1000: {
            perPage: 3,
            perMove: 3,
          },
          767: {
            pagination: false,
            perPage: 2,
            perMove: 2,
          },
          575: {
            pagination: false,
            perPage: 1,
            perMove: 1,
            padding: {
              right: 80,
            },
          },
        },
      }).mount({
        SlideNumber,
      });
    });
  }

  /* --------------------------- Promo box slider --------------------------- */
  if ($("[data-promo-box-slider]").length > 0) {
    $("[data-promo-box-slider] .promoSlider").each(function () {
      var sliderId = $(this).attr("id");
      new Splide("#" + sliderId, {
        perPage: 6,
        perMove: 6,
        pagination: true,
        gap: "20px",
        interval: 3000,
        breakpoints: {
          1979: {
            perPage: 5,
            perMove: 5,
          },
          1279: {
            perPage: 4,
            perMove: 4,
          },
          991: {
            perPage: 3,
            perMove: 3,
          },
          767: {
            pagination: false,
            perPage: 2,
            perMove: 2,
          },
          575: {
            pagination: false,
            perPage: 1,
            perMove: 1,
            padding: {
              right: 80,
            },
          },
        },
      }).mount({
        SlideNumber,
      });
    });
  }

  if ($("[data-promo-box-mini-slider]").length > 0) {
    $("[data-promo-box-mini-slider] .promoSlider--mini").each(function () {
      var sliderId = $(this).attr("id");
      new Splide("#" + sliderId, {
        perPage: 4,
        perMove: 4,
        pagination: true,
        gap: "20px",
        interval: 3000,
        breakpoints: {
          991: {
            perPage: 2,
            perMove: 2,
          },
        },
      }).mount();
    });
  }

  /* --------------------------- Special services slider --------------------------- */
  if ($("[data-services]").length > 0) {
    $("[data-services] .servicesSlider").each(function () {
      var sliderId = $(this).attr("id");
      new Splide("#" + sliderId, {
        perPage: 5,
        perMove: 5,
        arrows: true,
        pagination: true,
        gap: "10px",
        interval: 6000,
       /*  autoplay: true, */
        breakpoints: {
          991: {
            perPage: 4,
            perMove: 4,
          },
          767: {
            pagination: false,
            perPage: 3,
            perMove: 3,
          },
          479: {
            pagination: false,
            perPage: 2,
            perMove: 2,
          },
        },
      }).mount();
    });
  }

  /* --------------------------- Calendar Slider --------------------------- */
  if ($(".calendarSlider").length > 0) {
    new Splide(".calendarSlider", {
      perPage: 4,
      pagination: true,
      arrows: true,
      gap: "20px",
      breakpoints: {
        1199: {
          perPage: 3,
        },
        767: {
          perPage: 2,
          pagination: false,
        },
        479: {
          perPage: 1,
          pagination: false,
          padding: {
            right: 80,
          },
        },
      },
    }).mount({
      SlideNumber,
    });
  }
  // }

  /* --------------------------- Mpk twitter news slider --------------------------- */
  if ($("[data-mpk-slider]").length > 0) {
    new Splide(".mpkSlider", {
      perPage: 1,
      pagination: true,
      arrows: false,
      gap: "10px",
      interval: 6000,
      /* autoplay: true, */
    }).mount(); 
  }

  /****************************************** */
  /* --------------------------- Smart City slider --------------------------- */

  if ($(window).width() < 991 && $("[data-smartcity-slider]").length > 0) {
    new Splide(".smartcitySlider", {
      /* perPage: 2,
      pagination: false,
      arrows: false,
      gap: "30px",
      interval: 3000,*/
      breakpoints: {
        991: {
          perPage: 3,
          perMove: 3,
          pagination: true,
          arrows: false,
        },
        767: {
          perPage: 2,
          perMove: 2,
          pagination: true,
          arrows: false,
        },
      },
    }).mount();
  }

  /* --------------------------- Sekcja biuletyn - slider --------------------------- */
  // if ($("[data-bulletin-section-slider]").length > 0) {
  //   const bulletinSlider = new Splide(".bulletinSlider", {
  //     perPage: 3,
  //     perMove: 1,
  //     pagination: true,
  //     arrows: true,
  //     gap: "10px",
  //     padding: {
  //       right: 80,
  //     },
  //     breakpoints: {
  //       1199: {
  //         perPage: 2,
  //       },
  //       991: {
  //         perPage: 4,
  //       },
  //       767: {
  //         perPage: 3,
  //         padding: {
  //           right: 40,
  //         },
  //       },
  //       450: {
  //         perPage: 2,
  //         padding: {
  //           right: 80,
  //         },
  //       },
  //     },
  //   }).mount({
  //     SlideNumber,
  //   });
  // }

  /* --------------------------- Special info box - promoBox slider --------------------------- */
  if ($("[data-special-info-box-slider]").length > 0) {
    const promoBoxContent = document.querySelector(".promoBox__content");
    // window.onload = showSplideContent; event is not efficient for hiding photos while splide is still rendering
    showSplideContent();
    function showSplideContent() {
      setTimeout(takeOffHidingClass, 500);
    }
    function takeOffHidingClass() {
      promoBoxContent.classList.remove("hiddenContent");
    }
  }
  if (
    $("[data-special-info-box-slider] .splide__slide").length > 4 ||
    $(window).width() < 992
  ) {
    if ($("[data-promo-box-special]").hasClass("largeSpecialBox")) {
      new Splide(".largeBoxSliderMobile", {
        perPage: 4,
        pagination: false,
        arrows: true,
        gap: "20px",
        interval: 6000,
        breakpoints: {
          991: {
            perPage: 3,
          },
          767: {
            perPage: 2,
          },
          575: {
            pagination: false,
            // arrows: false,
            perPage: 1,
            padding: {
              right: 80,
            },
          },
        },
      }).mount();
    } else if ($("[data-promo-box-special]").hasClass("specialInfoBox")) {
      new Splide(".defaultSliderBox", {
        perPage: 4,
        pagination: true,
        arrows: true,
        gap: "20px",
        interval: 6000,
        breakpoints: {
          991: {
            perPage: 3,
            pagination: false,
          },
          767: {
            perPage: 2,
            pagination: false,
          },
          575: {
            // arrows: false,
            pagination: false,
            perPage: 1,
            padding: {
              right: 100,
            },
          },
          399: {
            // arrows: false,
            pagination: false,
            perPage: 1,
            gap: "10px",
            padding: {
              right: 50,
            },
          },
        },
      }).mount();
    }
  }

  $("[data-special-info-box-slider]").find('.splide__slide').each(function() {
    $(this).find('.boxTitle').show();
  });

  if (
    $("[data-special-info-box-slider] .splide__slide").length <= 4 &&
    $(window).width() > 991
  ) {
    $("[data-short-version]").addClass("shortVersion");
    $("[data-add-row]").addClass("row");
    $("[data-add-col]").addClass("col-lg-3");
  }

  if (
    $("[data-special-info-box-slider].largeBoxSliderMobile .splide__slide")
      .length > 4 ||
    $(window).width() < 992
  ) {
    $("[data-short-version]").addClass("longVersion");
  }

  // dodaję role wcag do listy
/*     $("[data-projects] [data-projects-slider]").each(function () {
      if ($(window).width() > 992) {
        $(".splide__list").attr("role", "list");  
        $(".splide__slide").attr("role", "listitem");    
      }

    if ($(window).width() < 992) {
      $(".splide__list").attr("role", "presentation");  
      $(".splide__slide").attr("role", "presentation");    
    }
  });   */
  
}



/* ---------------- WROCLAW TV ------------------------------------------------------------- */
function wroclawTvPlayer() {
  if ($("[data-player-plyr]").length === 0) return false;

  const player = new Plyr(".playerPlyr");

  $("[data-play-video]").click(function (e) {
    e.preventDefault();

    $("#bottomStickyBar").hide();
    $("[data-tv-box]").addClass("playVideo");
    $("[data-video-player]").append($(this).data("href"));
    $(".playerPlyr iframe")[0].src += "?autoplay=1";

    $("#tvBoxContainer").attr("tabindex", 0);
    trapFocus("#tvBoxContainer");
  });

  $("[data-play-video]").on("keydown", function (e) {
    if (e.keyCode === 13) {
      e.preventDefault();

      $("[data-tv-box]").addClass("playVideo");
      $("[data-video-player]").append($(this).data("href"));
      $(".playerPlyr iframe")[0].src += "?autoplay=1";

      $("#tvBoxContainer").attr("tabindex", 0);
      trapFocus("#tvBoxContainer");
    }
  });

  $("[data-close-video]").on("click", function (e) {
    e.preventDefault();

    $("#bottomStickyBar").show();
    $("[data-tv-box]").removeClass("playVideo");
    $("[data-video-player]").empty();
    $("#tvBoxContainer").removeAttr("tabindex");
  });
}

/* ---------------- NEWSLETTER ------------------------------------------------------------- */
function newsletter() {
  $("[data-submit]").on("click", function (e) {
    e.preventDefault();

    if ($("[data-placeholder]").val().length > 0) {
      var isCorrect = true;

      if (isCorrect && !validEmail($("[data-placeholder]"))) {
        isCorrect = false;

        Swal.fire({
          icon: "error",
          title: "Wprowadź poprawny adres e-mail",
        });
        changeHTMLTag("swal2-title", "h1");

        $(this).parent().addClass("error");
      } else {
        $(this).parent().removeClass("error");

        $.ajax({
          method: "GET",
          url: "https://www.wroclaw.pl/beta2/proxy/wroclaw-pl-strona-glowna/get-html-parts?type=newsletter_form",
          beforeSend: function () {
            $(".ajaxNewsletterForm").addClass("loading");
          },
        }).done((data, status) => {
          $(".ajaxNewsletterForm").removeClass("loading");

          if (status === "success") {
            let ajaxNewsletterForm =
              document.getElementsByClassName("ajaxNewsletterForm");
            ajaxNewsletterForm.item(0).insertAdjacentHTML("beforeend", data);

            $("[data-content]").addClass("expanded");

            trapFocus("#newsletter");
          }

          // Zamknij okno
          $("[data-close]").on("click", function (e) {
            e.preventDefault();
            $("[data-content]").removeClass("expanded");
            $(".newsletterForm").remove();
          });

          $("[data-close]").on("keydown", function (e) {
            if (e.keyCode === 13) {
              e.preventDefault();
              $("[data-content]").removeClass("expanded");
              $(".newsletterForm").remove();
            }
          });

          // wyswietl wiecej informacji
          $("[data-more-btn]").on("click", function () {
            e.preventDefault();
            dropdownContent($(this));
          });

          $("[data-more-btn]").on("keydown", function (e) {
            if (e.keyCode === 13) {
              e.preventDefault();
              dropdownContent($(this));
            }
          });

          $("[data-show-btn]").on("click", function () {
            e.preventDefault();
            $(this).parent().toggleClass("showInfo");
          });

          $("[data-show-btn]").on("keydown", function (e) {
            if (e.keyCode === 13) {
              e.preventDefault();
              $(this).parent().toggleClass("showInfo");
            }
          });

          // zaznaczenie input-checkbox za pomoca klawiatury
          $("input:checkbox").keypress(function (e) {
            if ((e.keyCode ? e.keyCode : e.which) == 13) {
              e.preventDefault();
              $(this).trigger("click");
            }
          });

          // Zapisz sie i wyslij
          $("[data-send-newsletter]").on("click", function (e) {
            e.preventDefault();

            $(".newsletterForm .newsletter").addClass("loading");

            var checkedNewsletterLists = [];
            $(".newsletterForm input[name='aList[]']:checked").each(
              function () {
                checkedNewsletterLists.push($(this).val());
              }
            );

            if (
              $("#iLegals").is(":checked") &&
              $("#iLegals2").is(":checked") === true &&
              checkedNewsletterLists.length > 0
            ) {
              $("[data-checkbox]").parent().removeClass("error");

              $.ajax({
                method: "POST",
                dataType: "json",
                url: "https://tools.api.wroclaw.pl/api/addFreshmailSubscriber",
                data: {
                  sEmail: $(".newsletter input[name=sEmail]").val(),
                  aList: checkedNewsletterLists,
                  iLegals: $("#iLegals").val(),
                  iLegals2: $("#iLegals2").val(),
                },
              }).done(function (response) {
                $("[data-placeholder]").val("");
                $("[data-content]").removeClass("expanded");
                $(".newsletterForm").remove();

                var isSuccess = false;

                $.each(response.freshmail_respone, function (key, value) {
                  if ($(this)[0].status == "OK") isSuccess = true;
                });

                if (isSuccess) {
                  $(".newsletterForm .newsletter").removeClass("loading");

                  Swal.fire({
                    icon: "success",
                    title: "Zapisałeś się do newslettera!",
                  });
                  changeHTMLTag("swal2-title", "h1");
                  

                  const el = document.getElementsByClassName("newsletter");
                  const x = el.focus();
                } else {
                  $(".newsletterForm .newsletter").removeClass("loading");
                  Swal.fire({
                    icon: "error",
                    title: "Twój adres jest już dodany do listy subskrybentów.",
                  });
                  changeHTMLTag("swal2-title", "h1");
                }
              });
            } else {
              $(".newsletterForm .newsletter").removeClass("loading");
              Swal.fire({
                icon: "error",
                title: "Uzupełnij wymagane pola.",
              });
              changeHTMLTag("swal2-title", "h1");

              if (checkedNewsletterLists.length == 0) {
                $(".newsletterForm input[name='aList[]']").each(function () {
                  $(this).parent().addClass("error");
                });
              }

              if ($("#iLegals").is(":checked") === false) {
                $("#iLegals").parent().addClass("error");
              } else {
                $("#iLegals").parent().removeClass("error");
              }

              if ($("#iLegals2").is(":checked") === false) {
                $("#iLegals2").parent().addClass("error");
              } else {
                $("#iLegals2").parent().removeClass("error");
              }
            }
          });
        });
      }
    } else {
      Swal.fire({
        icon: "error",
        title: "Wprowadź adres e-mail",
      });
      changeHTMLTag("swal2-title", "h1");

      $(this).parent().addClass("error");
    }

    var data = $("[data-placeholder]").val();
  });

  $(document).on("keydown", function (e) {
    if (e.keyCode === 27) {
      $("[data-content]").removeClass("expanded");
      $(".newsletterForm").remove();
    }
  });
}

function validationEmail(mail) {
  return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail);
}

function validEmail($obj) {
  if ($($obj).val().length > 0 && validationEmail($($obj).val())) {
    return true;
  }
}

// Zmien tag html na inny
function changeHTMLTag($elemClass, tagType) {
  const elemToChange = document.getElementsByClassName($elemClass);

  elemToChange.forEach((elem) => {
    elem.outerHTML =
      "<" + tagType + ">" + elem.innerHTML + "</" + tagType + ">";
  });
}

/* ---------------- TRAP FOCUS INSIDE MODAL --------------------------------------- */
function trapFocus($modalName) {
  // add all the elements inside modal which you want to make focusable
  const focusableElements =
    'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
  const modal = document.querySelector($modalName); // select the modal by it's id

  let firstFocusableElement = modal.querySelectorAll(focusableElements)[0]; // get first element to be focused inside modal
  let focusableContent = modal.querySelectorAll(focusableElements);
  let lastFocusableElement = focusableContent[focusableContent.length - 1]; // get last element to be focused inside modal

  document.addEventListener("keydown", function (e) {
     firstFocusableElement = modal.querySelectorAll(focusableElements)[0]; // get first element to be focused inside modal
     focusableContent = modal.querySelectorAll(focusableElements);
     lastFocusableElement = focusableContent[focusableContent.length - 1]; // get last element to be focused inside modal
    let isTabPressed = e.key === "Tab" || e.keyCode === 9;
    if (!isTabPressed) {
      return;
    }
    if (e.shiftKey) {
      // if shift key pressed for shift + tab combination
      if (document.activeElement === firstFocusableElement) {
        lastFocusableElement.focus(); // add focus for the last focusable element
        e.preventDefault();
      }
    } else {
      // if tab key is pressed
      if (document.activeElement === lastFocusableElement) {
        // if focused has reached to last focusable element then focus first focusable element after pressing tab
        firstFocusableElement.focus(); // add focus for the first focusable element
        e.preventDefault();
      }
    }
  });

  firstFocusableElement.focus();
}

/* ---------------- PROGRESS BOX - PRESIDENT SECTION --------------------------------------- */

const percentVal = $(".progressBox").data("percentval");

if ($(".projectsSlider .progressBox").length > 0) {
  if ($(".round").length > 0) {
    $(".round").each(function () {
      let $round = $(this),
        roundRadius = $round.find("circle").attr("r"),
        roundPercent = $round.data("percent"),
        roundCircum = 2 * roundRadius * Math.PI,
        roundDraw = (roundPercent * roundCircum) / 100;

      switch (roundPercent) {
        case 100 :
          $round.removeClass('none');
          $round.addClass('full');
          $round.css('stroke-dasharray', roundDraw  + ' 999');
          break
        case 0 :
          $round.addClass('none');
          break
        default :
          $round.removeClass('none');
          $round.css('stroke-dasharray', roundDraw  + ' 999');
      }

    });
  }
}

/* ---------------- DROPDOWN CONTENT ------------------------------------------------------- */
function dropdownContent($obj) {
  if ($obj.parent().hasClass("isExpanded")) {
    $obj.parent().removeClass("isExpanded");
    $obj.parent().find("[data-more-content]").stop().slideUp();
  } else {
    $obj.parent().addClass("isExpanded");
    $("[data-more-wrapper]")
      .removeClass("isExpanded")
      .find("[data-more-content]")
      .stop()
      .slideUp();
    $obj
      .parent()
      .addClass("isExpanded")
      .find("[data-more-content]")
      .stop()
      .slideDown();
  }
}

/* ---------------- MESSAGES WITH SWITCH - MAIN NEWS --------------------------------------- */
function switchButton() {
  if ($(window).width() > 991) {
    if (getCookie("infoWrapperSwitch") === "1") {
      switchBox();
    } else {
      $("[data-switch-wrapper]").addClass("isExpanded");
    }

    $("[data-switch-btn]").click(function () {
      switchBox();
    });

    // Zmiana switcha za pomocą klawisza - enter
    $("[data-switch-btn]").on("keydown", function (e) {
      if (e.keyCode === 13) {
        switchBox();
      }
    });

    // Zmiana switcha za pomocą klawisza - sapcji
    $("[data-switch-btn]").on("keydown", function (e) {
      if (e.keyCode === 32) {
        switchBox();
      }
    });
  }
}

function switchBox() {
  var $obj = $("[data-switch-wrapper]");

  if ($obj.hasClass("isExpanded")) {
    $obj.removeClass("isExpanded");
    $obj.find("[data-more-content]").stop().slideUp();
    $(".switchBox .readMore").text("Nieaktywny");
    setCookie("infoWrapperSwitch", 1, 365);
  } else {
    $obj.addClass("isExpanded");
    $obj.removeClass("isExpanded").find("[data-more-content]").stop().slideUp();
    $obj.addClass("isExpanded").find("[data-more-content]").stop().slideDown();
    $(".switchBox .readMore").text("Aktywny");
    setCookie("infoWrapperSwitch", 0, 365);
  }
}

//  Zmiana wartosci atrybuty aria-checked w elemencie switch po kliku w element
class Switch {
  constructor(domNode) {
    this.switchNode = domNode;
    this.switchNode.addEventListener("click", () => this.toggleStatus());
    this.switchNode.addEventListener("keydown", (event) =>
      this.handleKeydown(event)
    );
  }

  handleKeydown(event) {
    // Only do something when space or return is pressed
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      this.toggleStatus();
    }
  }

  // Switch state of a switch
  toggleStatus() {
    const currentState =
      this.switchNode.getAttribute("aria-checked") === "true";
    const newState = String(!currentState);

    this.switchNode.setAttribute("aria-checked", newState);
  }
}

// Initialize switches
window.addEventListener("load", function () {
  // Initialize the Switch component on all matching DOM nodes
  Array.from(document.querySelectorAll("[role^=switch]")).forEach(
    (element) => new Switch(element)
  );
});

// Coookies
function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  var expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

/* ---------------- TIMETABLES ON SELECT & READING MORE ELEMENTS ON MOBILE ---------------------- */
$(function (e) {
  /* ---------------- TIMETABLES ON SELECT -------------------------------------------------- */

  var oBus = $("#busLine");
  $("#busLine")
    .select2({
      placeholder: "Wybierz linię",
      language: {
        noResults: function () {
          return "Brak wyników";
        },
      },
    })
    .on("select2:opening", function (e) {
      if (!oBus.hasClass("loaded")) {
        e.preventDefault();
        oBus.parent().addClass("loading");
        $.ajax({
          method: "GET",
          url: "https://www.wroclaw.pl/komunikacja/bus/getDataByAjax?action=get-lines-list",
          dataType: "json",
          cache: true,
        }).done(function (oData) {
          var dataArray2 = oData.line;
          dataArray2.forEach(function (currentValue, index, arr) {
            var newOption = new Option(
              dataArray2[index].name,
              dataArray2[index].url,
              false,
              false
            );
            oBus.append(newOption);
          });
          oBus.addClass("loaded");
          oBus.parent().removeClass("loading");
          oBus.select2("open");
        });
      }
    })
    .on("select2:selecting", function (e) {
      window.location = e.params.args.data.id;
    });

  var oStreets = $("#street");
  oStreets
    .select2({
      placeholder: "Wybierz przystanek",
      // ajax: {
      //     url: 'https://proxy.dev.wroclaw.pl/tools/proxy/getlist.php?json',
      //     dataType: 'json'
      // },
      language: {
        noResults: function () {
          return "Brak wyników";
        },
      },
    })
    .on("select2:opening", function (e) {
      if (!oStreets.hasClass("loaded")) {
        e.preventDefault();
        oStreets.parent().addClass("loading");
        $.ajax({
          method: "GET",
          url: "https://www.wroclaw.pl/komunikacja/bus/getDataByAjax?action=get-stops-list",
          dataType: "json",
          cache: true,
        }).done(function (oData) {
          var dataArray2 = oData.street;
          dataArray2.forEach(function (currentValue, index, arr) {
            var newOption = new Option(
              dataArray2[index].name,
              dataArray2[index].url,
              false,
              false
            );
            oStreets.append(newOption);
          });
          oStreets.addClass("loaded");
          oStreets.parent().removeClass("loading");
          oStreets.select2("open");
        });
      }
    })
    .on("select2:selecting", function (e) {
      window.location = e.params.args.data.id;
    });

  /* ---------------- READING MORE ELEMENTS ON MOBILE -------------------------------------- */
  // if ($(window).width() < 992) {
  //   let boxNb = false;

  //   $(".showMore").click(function (e) {
  //     if ($(this).hasClass("redirect")) {
  //       e.preventDefault();
  //       showHiddenLink($(this));

  //       let success = function (resp) {
  //         resp = $.parseJSON(resp);

  //         if (boxNb === false) {
  //           preparePopupContent(resp.data);

  //           boxNb = true;
  //           return;
  //         }
  //       };

  //       $.ajax({
  //         type: "POST",
  //         url: "xhr/more_articles",
  //         //data: data,
  //         success: success,
  //         //dataType: dataType
  //       });
  //       $(this).removeClass("redirect");
  //       $(this).addClass("arrow");
  //       $(this).text("Więcej");
  //     } else {
  //       window.location.href = "index.html";
  //     }
  //   });

  //   $(".showMoreNews").click(function (e) {
  //     if ($(this).hasClass("redirect")) {
  //       e.preventDefault();
  //       showHiddenLink($(this));
  //       $(this).removeClass("redirect");
  //       $(this).addClass("arrow");
  //       $(this).text("Więcej");
  //     } else {
  //       window.location.href = "index.html";
  //     }
  //   });
  // }
});

/* ---------------- DROPDOWN ON MOBILES --------------------------------------------------- */
$(function () {
  if ($(window).width() < 768) {
    $(".dropdownContent .dropdownHeader").click(function () {
      dropdownContent($(this));
    });
  }
});

function preparePopupContent(data) {
  for (let i = 0; i < data.length; i++) {
    // $(this).parent().siblings().hasClass
    $(".boxList").append(`
      <li class="col-6 col-lg-12">
        <a class="boxWithImg" href="${data[i].seo_alias}">
          <div class="imgWrapper">
            <img loading="lazy" src="${data[i].photo}" height="165" width="250" alt="">
          </div>
          <div class="boxData">
            <time class="articleDate" datetime="${data[i].create_time}">${data[i].create_time}</time>
            <h3 class="boxTitle">${data[i].title}</h3>
          </div>
        </a>
      </li>
    `);
  }
}

function showHiddenLink($obj) {
  $obj
    .closest("[data-hidden-wrapper]")
    .find("[data-hidden-link] li")
    .each(function () {
      if ($(this).hasClass("hidden-tabletmobile")) {
        $(this).removeClass("hidden-tabletmobile");
      }

      if ($(this).hasClass("hideBottomLine")) {
        $(this).removeClass("hideBottomLine");
      }
    });
}

/* ---------------- FOR SHORTS ON MOBILE - SHOW MORE CONTENT ON CLICK -------------------- */
function showMoreContent($obj, number) {
  $obj.on("click", function (e) {
    e.preventDefault();
    const boxWrapper = $(this).closest("[data-info-wrapper]");

    if (boxWrapper.hasClass("expanded")) {
      boxWrapper.removeClass("expanded");
      $(this).attr("aria-expanded", "false");
      $(this).find("[data-change-txt]").text("Rozwiń");

      boxWrapper.find("[data-li]").each(function (i) {
        if (i >= number) $(this).addClass("hideMobile");
      });
    } else {
      boxWrapper
        .addClass("expanded")
        .find("[data-li]")
        .removeClass("hideMobile");
      $(this).attr("aria-expanded", "true");
      $(this).find("[data-change-txt]").text("Zwiń");
    }
  });
}

/* ---------------- PRACTICAL INFO BAR - ON MOBILE - HIDE ON SCROLLED DOWN --------------- */
function bottomStickyBar() {
  if ($("#bottomStickyBar ul li").length > 0) {
    if ($(window).width() < 768) {
      $("body").addClass("moveWidget");
    }
  }
}

$(function () {
  // Change tab index
  $("[data-content-id]").on("click", function () {
    changeTabContent($(this));

    if ($("[data-content-id-wrapper]").length) {
      scrollToObj($("[data-content-id-wrapper]"), 60, 800);
    }
  });

  $("[data-content-id]").on("keydown", function (e) {
    if (e.keyCode === 13) {
      changeTabContent($(this));

      if ($("[data-content-id-wrapper]").length) {
        scrollToObj($("[data-content-id-wrapper]"), 60, 800);
      }
    }
  });
});

/* ---------------------------------- CHANGE CONTENT - TAB ---------------------------------- */
function changeTabContent($obj) {
  $("[data-content-id]").removeClass("active");
  $("[data-change-content]").removeClass("active");
  $obj.addClass("active");

  var content = $obj.attr("data-content-id");
  $("#" + content).addClass("active");
}

/* ---------------------------------- SCROLL TO ELEMENT ---------------------------------- */
function scrollToObj($obj, $offset, $time) {
  if ($.isNumeric($obj)) {
    return;
  }
  if ($(window).width() > 769) {
    $("html, body").animate(
      {
        scrollTop: $obj.offset().top - $offset,
      },
      $time
    );
  } else {
    $("html, body").animate(
      {
        scrollTop: $obj.offset().top - 50 - $offset,
      },
      $time
    );
  }
}

$(function () {
  $("[data-seeMoreItems]").on("click", function (e) {
    e.preventDefault();

    if ($("[data-moreItems]").hasClass("open")) {
      $("[data-moreItems]").removeClass("open");
      $("[data-seeMoreItems]").find("data-moreItems").stop().slideDown();
    } else {
      $("[data-moreItems]").addClass("open");
      $("[data-seeMoreItems]").find("data-moreItems").stop().slideUp();
    }
  });

  // herovideo
  $("#heroVideoPlay").on("click", function () {
    console.log("ssss");
    $(this).fadeOut();
    $(".heroContent").fadeOut();
    $("#heroVideo")[0].play();
    $(".hero.videoStyle").addClass("play");
    setTimeout(function () {
      $("#closeVideo").addClass("show");
    }, 400);
  });

  $("#closeVideo").click(function () {
    $(this).removeClass("show");
    $("#heroVideo")[0].load();
    setTimeout(function () {
      $(".heroContent").fadeIn();
      $("#heroVideoPlay").fadeIn();
      $(".hero.videoStyle").removeClass("play");
    }, 400);
  });

  $("#heroVideo").on("webkitendfullscreen", function (e) {
    $("#closeVideo").trigger("click");
  });
});

/* ----------------------------------  Usunięcie reklamy w mainNews na desktop ---------------------------------- */
// TODO - zastanowic sie czy kod jest potrzebny, czy mozna go usunac.

// if ($(window).width() > 991) {
//   var div = document.getElementById('removeDesktop');
//     div.remove();
// }

/* ----------------------------------  Countdown Timer ---------------------------------- */

function handleTickInit(tick) {
  // set language
  var locale = {
    // YEAR_PLURAL: 'lata',
    // YEAR_SINGULAR: 'rok',
    MONTH_PLURAL: "miesiący",
    MONTH_SINGULAR: "miesiąc",
    WEEK_PLURAL: "tygodni",
    WEEK_SINGULAR: "tydzień",
    DAY_PLURAL: "dni",
    DAY_SINGULAR: "dzień",
    HOUR_PLURAL: "godzin",
    HOUR_SINGULAR: "godzina",
    MINUTE_PLURAL: "minut",
    MINUTE_SINGULAR: "minuta",
    SECOND_PLURAL: "sekund",
    SECOND_SINGULAR: "sekunda",
    // MILLISECOND_PLURAL: 'milisekundy',
    // MILLISECOND_SINGULAR: 'milisekunda'
  };

  for (var key in locale) {
    if (!locale.hasOwnProperty(key)) {
      continue;
    }
    tick.setConstant(key, locale[key]);
  }

  // format of due date is ISO8601
  // https://en.wikipedia.org/wiki/ISO_8601

  // '2018-01-31T12:00:00'        to count down to the 31st of January 2018 at 12 o'clock
  // '2019'                       to count down to 2019
  // '2018-01-15T10:00:00+01:00'  to count down to the 15th of January 2018 at 10 o'clock in timezone GMT+1

  // create the countdown counter
  var counter = Tick.count.down("2022-10-10T23:59:59");

  counter.onupdate = function (value) {
    tick.value = value;
  };

  counter.onended = function () {
    // hide counter, uncomment the next line
    tick.root.style.display = "none";

    // show message, uncomment the next line
    document.querySelector(".tick-onended-message").style.display = "";
  };
}

// Tłumaczenie dla btn w juicerze
function translateJuicer() {
  jQuery(".j-paginate").text("Załaduj więcej");
  jQuery(".j-read-more").text("Czytaj więcej");
}

// Dodanie klasy dla boksow 'na skróty'
$(function () {
  var shortcutsBox = $("[data-shortcuts-class] a");

  if ($(window).width() > 767) {
    shortcutsBox.addClass("shortcutsDesktop");
    shortcutsBox.removeClass("shortcutsMobile");
  } else {
    shortcutsBox.addClass("shortcutsMobile");
    shortcutsBox.removeClass("shortcutsDesktop");
  }
});

// Sprawdza czy urządzenie jest iPhone, jesli tak, to dodaje padding bottom do #bottomStickyBar na mobilkach
$(function () {
  if (/iPhone/i.test(navigator.userAgent)) {
    const eachLi = document.querySelectorAll('#bottomStickyBar .info__list > li');
    eachLi.forEach(element => {
      element.style.paddingBottom = '10px';
    });
  }
});


console.log('MAIN SCRIPT');